const userActionTypes = {
    RETRIEVED_USERS: "RETRIEVED_USERS",
    RETRIEVED_USER_DETAILS: "RETRIEVED_USER_DETAILS",
    CREATE_USER: "CREATE_USER",
    UPDATE_USER: "UPDATE_USER",
    DELETE_USER: "DELETE_USER",
    ERASE_USER: "ERASE_USER",
    RESTORE_USER: "RESTORE_USER",
    RETRIEVED_USER_FILTERS: "RETRIEVED_USER_FILTERS",
    USER_MADE_SUPERUSER: "USER_MADE_SUPERUSER",
    RETRIEVED_USERS_ROLES: "RETRIEVED_USERS_ROLES",
    RETRIEVED_SUGGEST_ROLES: "RETRIEVED_SUGGEST_ROLES",
    SAVE_USER_ROLE: "SAVE_USER_ROLE",
    REMOVE_USER_ROLE: "REMOVE_USER_ROLE",
    UPDATE_USER_AUTHORIZE_STATUS: "UPDATE_USER_AUTHORIZE_STATUS",
    USER_UNLOCKED:"USER_UNLOCKED",
    RETRIEVED_PASSWORD_STRENGTH_OPTIONS: "RETRIEVED_PASSWORD_STRENGTH_OPTIONS"

};
export default userActionTypes;
